
export const Ipid = () => {
    return <a href='../ipid' target='_blank'>insurance product information document</a>
}